import { ConcreteFormStepProps } from './interfaces'
import { useTranslation } from 'react-i18next'
import { NextStep } from '../components/NextStep'
import { FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material'
import React from 'react'
import { useStepForm } from './hooks'
import * as yup from 'yup'
import { Controller } from 'react-hook-form'
import { ChainSelect } from '../components/ChainSelect'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

export const Chain = ({ values, onSubmit, lead }: ConcreteFormStepProps) => {
    const { t } = useTranslation()
    const schema = yup.object({
        isChainMember: yup.boolean(),
        chainName: yup.string().when('isChainMember', {
            is: true,
            then: (schema) => schema.required(),
        }),
        chainMembershipNumber: yup.string().when('isChainMember', {
            is: true,
            then: (schema) => schema.required(),
        }),
        chainMemberSince: yup.date().when('isChainMember', {
            is: true,
            then: (schema) => schema.required().max(new Date()),
        }),
    })
    const {
        control,
        handleSubmit,
        augmentedFieldProps,
        watch,
    } = useStepForm('Chain', schema, values, false)

    const isChainMember = watch('isChainMember')

    const onSubmitWithDataTransform = (data: Record<string, any>) => {
        onSubmit({
            ...data,
            chainName: data.isChainMember ? data.chainName : null,
            chainMembershipNumber: data.isChainMember ? data.chainMembershipNumber : '',
            chainMemberSince: data.isChainMember && data.chainMemberSince ? data.chainMemberSince.getFullYear() + "-" + (data.chainMemberSince.getMonth()+1) + "-" + data.chainMemberSince.getDate() : null,
        })
    }

    return <>
        <Typography mb={4} variant="h5" component="h1">{t('Chain.heading')}</Typography>

        <form onSubmit={handleSubmit(onSubmitWithDataTransform)}>
            <Controller
                name="isChainMember"
                control={control}
                defaultValue={false}
                render={({ field }) => <FormControlLabel
                    control={<Switch {...field} checked={!!field.value}/>}
                    label={t('Chain.isChainMember.label', {companyName: lead.companyName})}
                />}
            />

            <Stack mt={3} spacing={3} sx={{ width: 400, maxWidth: '100%', display: isChainMember ? 'block' : 'none' }}>
                <Controller
                    name="chainName"
                    control={control}
                    render={({ field }) =>
                        <ChainSelect
                            {...augmentedFieldProps(field)}
                        />
                    }
                />
                <Controller
                    name="chainMembershipNumber"
                    control={control}
                    defaultValue=""
                    render={({ field }) =>
                        <TextField
                            {...augmentedFieldProps(field)}
                            fullWidth={true}
                        />
                    }
                />
                <Controller
                    name="chainMemberSince"
                    control={control}
                    render={({ field }) =>
                        <DatePicker
                            disableFuture={true}
                            {...augmentedFieldProps(field)}
                            renderInput={(params) => <TextField
                                {...params}
                                helperText={augmentedFieldProps(field).helperText}
                                error={augmentedFieldProps(field).error}
                            />}
                        />
                    }
                />
            </Stack>
            <NextStep/>
        </form>
    </>
}
